export default __webpack_public_path__ + "static/media/deliveryman.e6abd08c.svg";